<div class="error-container">
  <div class="error-content">
    <img class="error-image" src="./assets/img/404.png" />
    <h1 class="error-title">{{ title }}</h1>
    @if (additionalText) {
      <p class="text-center">{{ additionalText }}</p>
    }
    @if (showRetryButton) {
      <div class="error-buttons-wrapper">
        <button
          mytcDisabledWhileOffline
          class="try-again-button"
          translate="error.tryAgain"
          (click)="retry.emit()"></button>
      </div>
    }
  </div>
</div>
